<template>
  <v-dialog v-model="show" persistent @keydown.esc="hide" width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ title }}
      </v-card-title>

      <v-card-text>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateFormatted"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="selectedDate"
            no-title
            @input="onDateSelected"
          ></v-date-picker>
        </v-menu>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="hide">{{ $t("dialog.cancel") }}</v-btn>
        <v-btn
          :disabled="selectedDate == date"
          color="primary"
          text
          @click="save"
          >{{ $t("dialog.save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    date: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedDate: this.date,
      dateFormatted: this.formatDate(this.selectedDate),
      menu: false,
    };
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        return;
      }
      this.dateFormatted = this.formatDate(this.date);
    },
    date(newVal) {
      if (!newVal) {
        return;
      }
      this.selectedDate = newVal;
    },
  },
  methods: {
    hide() {
      this.$emit("update:show", false);
    },
    save() {
      this.$emit("change", this.convertDateToExpectedFormat(this.selectedDate));
      this.hide();
    },
    convertDateToExpectedFormat(dateStr) {
      if (dateStr) {
        return dateStr + "T00:00:00Z";
      }
      return "";
    },
    onDateSelected(date) {
      this.menu = false;
      this.selectedDate = date;
      this.dateFormatted = this.formatDate(this.selectedDate);
    },
    formatDate(date) {
      return this.$options.filters.date(date);
    },
  },
};
</script>
